<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="input" label="优惠券名称" name="coupon_name"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="state"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" @click="navigateTo('/coupon_add')">新建优惠券</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="审核状态"
					name="state"
				>
					<template v-slot="{data}">
            <span v-if="data.state == 0" style="color:#999">{{stateText[data.state]}}</span>
            <span v-if="data.state == 1" style="color:dodgerblue">{{stateText[data.state]}}</span>
            <span v-if="data.state == 2" style="color:green">{{stateText[data.state]}}</span>
            <span v-if="data.state == -1" style="color:red">{{stateText[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="优惠券名称"
					name="coupon_name"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="优惠券类型"
					name="coupon_kinds"
				>
					<template v-slot="{data}">
						{{dict.couponType[data.coupon_kinds]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="优惠力度"
					name="detail"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="适用范围"
					name="commodity_range"
					width="80"
				>
					<template v-slot="{data}">
						{{dict.couponRange[data.commodity_range]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发放总量"
					name="available_amount"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="已领取"
					name="received_amount"
					width="60"
				></c-table-column>
				
				<c-table-column
					label="已使用"
					name="used_count"
					width="60"
				></c-table-column>
				
				<c-table-column
					label="待使用"
					name="valid_count"
					width="60"
				></c-table-column>
				
				<c-table-column
					label="已失效"
					name="invalid_count"
					width="60"
				></c-table-column>
				
				<c-table-column
					label="剩余可领"
					name="surplus"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="创建人"
					name="create_user_realname"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="审核时间"
					name="approval_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="row">
						<c-table-button v-if="row.data.state != 0" @click="navigateTo(`/coupon_detail/${row.data.id}`)">查看</c-table-button>
						<c-table-button v-if="row.data.state <= 0" @click="navigateTo(`/coupon_edit/${row.data.id}`)">编辑</c-table-button>
						<c-table-button v-if="row.data.state <= 0" @click="deleteCoupon(row)">删除</c-table-button>
						<c-table-button v-if="row.data.state == 1" @click="navigateTo(`/coupon_verify/${row.data.id}`)">审核</c-table-button>
						<c-table-button v-if="row.data.state == 2" @click="setCount(row)">设置数量</c-table-button>
						<c-table-button v-if="row.data.state == 2" @click="copyCoupon(row)">复制</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="countDialog" title="设置数量" width="400" height="200" @resolve="setCountHandle">
			<c-form ref="countForm">
				<c-form-item type="number" label="剩余数量" name="coupon_count" required></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'm_coupon_info',

        props: {
            apply_state: String
        },

		data() {
			return {
				state: [{
					name: '草稿',
					value: 0
				}, {
					name: '待审核',
					value: 1
				}, {
					name: '审核通过',
					value: 2
				}, {
					name: '驳回',
					value: -1
				}]
			}
		},

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },
		
		computed: {
			...mapState(['dict']),
			
			stateText() {
				var state = {};
				this.state.forEach(item => {
					state[item.value] = item.name;
				});
				
				return state;
			},

            defaultSearch() {
			    console.log(this.apply_state,'--')
                let param = {
                    state: this.apply_state ? this.apply_state.split(',') : [],
                }

                return param;
            }
		},
		
		mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
			this.$bus.$on('couponList.update', () => {
				this.$refs.search.search();
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/couponInfo/list',
					data
				});
			},
			
			deleteCoupon(item) {
				this.$confirm({
					text: '确定要删除此优惠券吗？',
					resolve: () => {
						this.request({
							url: '/couponInfo/delete',
							data: {
								id: item.data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			},
			
			setCount(item) {
				this._edit = item;
				this.$refs.countForm.set({
					coupon_count: item.data.surplus
				});
				this.$refs.countDialog.open();
			},
			
			setCountHandle(stop) {
				stop();
				this.$refs.countForm.submit({
					url: '/couponInfo/updateCount',
					
					rule: {
						coupon_count: '请填写剩余数量'
					},
					
					dataFormatter: data => {
						data.id = this._edit.data.id;
						return data;
					},
					
					success: data => {
						this.$refs.table.update();
						this.$refs.countDialog.close();
						this.$message({
							text: '设置成功'
						});
					}
				})
			},
			
			copyCoupon(item) {
				this.request({
					url: '/couponInfo/copy',
					data: {
						id: item.data.id
					},
					loading: true,
					success: () => {
						this.$message({
							text: '复制成功'
						});
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>